import { cn } from '../lib/cn.js'

/** Número do relatório do dia. Valor em Anton, para ser lido num relance. */
export function StatTile({
  rotulo,
  valor,
  apoio,
  extra,
  tom = 'neutro',
  className,
}: {
  rotulo: string
  valor: string
  apoio?: string | undefined
  /**
   * Slot embaixo do apoio, para o que não cabe em texto corrido — a variação
   * contra o período anterior, com seta e cor. Existe porque um número de
   * dashboard sozinho não diz nada: R$ 4.200 é bom ou ruim depende do mês
   * passado, e essa comparação precisa de ícone, não de string.
   */
  extra?: React.ReactNode | undefined
  tom?: 'neutro' | 'marca' | 'destaque' | undefined
  className?: string | undefined
}) {
  return (
    <div className={cn('du-stat', `du-stat--${tom}`, className)}>
      <span className="du-stat__rotulo">{rotulo}</span>
      <span className="du-stat__valor">{valor}</span>
      {apoio ? <span className="du-stat__apoio">{apoio}</span> : null}
      {extra ? <span className="du-stat__extra">{extra}</span> : null}
    </div>
  )
}
